import React, { PureComponent } from 'react';
import { Route, Switch } from 'react-router-dom';

import Form from './form';
import List from './list';

export default class Office extends PureComponent {
  render() {
    return (
      <Switch>
        <Route component={List} exact path={this.props.match?.path} />
        <Route
          component={Form}
          exact
          path={`${this.props.match?.path}/create`}
        />
        <Route
          component={Form}
          exact
          path={`${this.props.match?.path}/:id/edit`}
        />
      </Switch>
    );
  }
}
